<template>
  <div class="index main">
    <div class="drag-info">
      <div class="drag-info-content">
        <img src="/static/img/icons/move.svg" class="drag-icon" />
        <p>
          Чтобы поменять местами строки удерживайте и перетаскивайте их. <br />
          Порядок отображения строк влияет на порядок отображения пунктов в
          форме
        </p>
      </div>
    </div>

    <h2 class="centered">Форма сбора заявок</h2>
    <div class="switch-wrapper">
      <b-switch v-model="mutateClaimInfo.enable" @input="handleClaimInfoChange">
        Отображать на главной странице
      </b-switch>
    </div>
    <draggable
      group="order"
      class="drag-area"
      :value="claims"
      @change="handleOrderChange($event)"
      ghost-class="ghost"
    >
      <Claim
        class="row"
        v-for="claim in claims"
        :key="claim.id"
        :claim="claim"
      />
      <span class="button-wrapper centered" @click="handleAddClaim">
        <a class="button is-info">+</a>
        Добавить
      </span>
    </draggable>

    <div class="row-wrapper row">
      <div class="field-wrapper underwriting">
        <span class="input-label">Брокеры</span>
        <input type="file" @change="handleBrokersChange" />
      </div>
    </div>
    <div class="save-content-button centered">
      <button
        class="button save-content"
        :disabled="disabled"
        @click="handleSavePage"
      >
        {{ disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ' }}
      </button>
      <button class="button" @click="exportToCSV" :disabled="disabled">
        Экспорт в csv
      </button>
    </div>
    <div class="centered shedule-header">
      <h3 class="shedule-title">Интервал синхронизации</h3>
      <p>Значение задается в минутах.</p>
      <p>При значении <code>0</code> синхронизации не происходит.</p>
    </div>
    <div class="centered shedule-controls">
      <input
        type="number"
        v-model="mutateClaimInfo.timeForSync"
        @input="handleClaimInfoChange"
        class="input shedule-input"
        min="0"
      />
      <button
        class="button"
        @click="handleSendTimeForSync"
        :disabled="disabled"
      >
        {{ disabled ? 'Идет сохранение...' : 'Сохранить' }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import draggable from 'vuedraggable'
import deepcopy from 'deepcopy'
import { v4 as uuidv4 } from 'uuid'
import Claim from 'components/Underwriting/Claim'

export default {
  name: 'Underwriting',
  data() {
    return {
      disabled: false
    }
  },
  components: {
    draggable,
    Claim
  },
  created() {
    this.getClaimInfo()
    this.getClaims()
  },
  computed: {
    ...mapState(['claimInfo', 'claims', 'submissionAppOperations']),
    mutateClaimInfo() {
      return deepcopy(this.claimInfo)
    }
  },
  methods: {
    ...mapActions([
      'getClaimInfo',
      'updateClaimInfo',
      'getClaims',
      'addClaim',
      'loadBrokers',
      'saveUnderwritingPage',
      'getSubmissionAppOperations',
      'sendTimeForSync'
    ]),
    handleClaimInfoChange() {
      this.updateClaimInfo(deepcopy(this.mutateClaimInfo))
    },
    handleAddClaim() {
      const newClaim = {
        id: uuidv4(),
        title: 'Заголовок',
        showDateTimeMin: new Date(),
        showDateTimeMax: new Date(),
        showDateTimeUntilMin: new Date(),
        showDateTimeUntilMax: new Date(),
        proposalDateTimeMin: new Date(),
        proposalDateTimeMax: new Date(),
        claimUpdatingDateTime: new Date(),
        type: 'initial',
        amountMin: 0,
        amountMax: 0,
        priceMin: 0,
        priceMax: 0,
        showPercent: false,
        rateMin: 0,
        rateMax: 0,
        mult: 0,
        maxSum: 0,
        allocation: true,
        onlyForQualified: false,
        testingRequired: false,
        order: this.claims.length + 1
      }

      this.addClaim(newClaim)
    },
    handleOrderChange(event) {
      let values = deepcopy(this.claims)

      if (event.moved) {
        if (event.moved.newIndex > event.moved.oldIndex) {
          values[event.moved.oldIndex].order += 1
          values[event.moved.newIndex].order -= 1
        } else {
          values[event.moved.oldIndex].order -= 1
          values[event.moved.newIndex].order += 1
        }
      }

      values = values.sort((a, b) => a.order - b.order)

      this.$store.commit('SET_CLAIMS', values)
    },
    handleBrokersChange(e) {
      this.loadBrokers(e.target.files[0]).then(() => {
        this.disabled = false
        this.$toast.open({ message: 'Загружено' })
      })
      e.target.value = ''
    },
    handleSavePage() {
      this.disabled = true
      this.saveUnderwritingPage().then(() => {
        this.disabled = false
        this.$toast.open({ message: 'Сохранено' })
      })
    },
    async exportToCSV() {
      await this.getSubmissionAppOperations().then(() => {
        const operations = this.submissionAppOperations
        let csvContent = 'data:text/csv;charset=utf-8,'
        if (operations.length > 0) {
          csvContent += [
            Object.keys(operations[0]).join(','),
            ...operations.map((item) => Object.values(item).join(','))
          ]
            .join('\n')
            .replace(/(^\[)|(\]$)/gm, '')
        }

        const data = encodeURI(csvContent)
        const link = document.createElement('a')
        link.setAttribute('href', data)
        link.setAttribute('download', 'submissionAppOperations.csv')
        link.click()
      })
    },
    handleSendTimeForSync() {
      this.disabled = true
      this.saveUnderwritingPage().then(() => {
        this.sendTimeForSync(this.mutateClaimInfo.timeForSync)
        this.disabled = false
        this.$toast.open({ message: 'Сохранено' })
      })
    }
  }
}
</script>

<style>
.drag-info {
  max-width: 600px;
  margin: 0 auto;
  background: #3273dc;
  padding: 10px;
  border-radius: 15px;
  color: #fff;
}
.drag-icon {
  margin: 0 10px 0 0;
  width: 25px;
}
.drag-area {
  min-height: 100px;
}
.drag-info-content {
  display: flex;
  align-items: center;
  font-size: 14px;
}
h2 {
  font-weight: bold;
  margin: 15px 0 5px 0;
  font-size: 22px;
}
.switch-wrapper {
  margin: 0 auto;
}
.switch span {
  color: #1464f6;
}
.row-wrapper {
  padding: 0.5rem !important;
  max-width: 500px;
  border: 1px solid transparent;
  border-radius: 4px;
}
.field-wrapper.underwriting {
  display: grid;
  grid-template-columns: 1fr 3fr 1fr 3fr;
  align-items: center;
  grid-column-gap: 20px;
}
.input-label {
  font-size: 0.9rem;
  color: #363636;
  margin: 5px 0;
  user-select: none;
}
.ghost {
  cursor: grab;
  border-color: rgba(0, 0, 0, 0.15);
}

.save-content-button .button:not(:last-child) {
  margin-right: 20px;
}

.shedule-header {
  flex-direction: column;
  margin-top: 28px;
  margin-bottom: 20px;
}

.shedule-title {
  font-weight: bold;
  margin-bottom: 12px;
  font-size: 18px;
}

.shedule-controls {
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 40px;
}

.shedule-input {
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// Index.vue?03897670